<script>
import { mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  GET_JPSTORE_CHILD_FORM,
  RESET_JPSTORE_CHILD_FORM,
  RESET_JPSTORE_GMO_EXTRA_PARAM,
  UPDATE_JPSTORE_GMO_EXTRA_PARAM
} from '@store/officialWebStore/jp';
import Input from './editor/Input.vue';

export default {
  name: 'GMOSelectPopup',
  props: {
    curPayType: {
      type: Object,
      default: () => {}
    },
    postProductDesc: {
      type: String,
      default: ''
    },
    amountDesc: {
      type: String,
      default: ''
    },
    discountTransMount: {
      type: String,
      default: ''
    }
  },
  components: {
    Input
  },
  data() {
    return {
      canClick: false,
      isload: false,
      showDropdown: false,
      selectedItem: null,
      formData: {},
      submitTips: ''
    };
  },
  emits: ['hidePopup', 'submit'],
  computed: {
    ...mapState({
      jpChildList: state => state.jp.jpChildList,
      jpChildForm: state => state.jp.jpChildForm
    })
  },
  methods: {
    hidePopup() {
      this.$emit('hidePopup');
    },
    selectItem(item) {
      this.selectedItem = item;
      this.showDropdown = false;
    },
    updateChildChannel(item) {
      this.selectedItem = item;
      this.showDropdown = false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    updateFormValue(data) {
      this.formData[data.attr] = data.value;
    },
    resetFormValue() {
      this.formData = {};
    },
    closeSubmitTips() {
      this.submitTips = '';
    },
    getAllData() {
      // 获取formData里面value不为空的kv
      const realFormData = Object.fromEntries(
        Object.entries(this.formData).filter(([_, value]) => value !== '')
      );
      const res = {
        ...realFormData,
        child_id: this.selectedItem?.id,
      };
      this.$store.commit(UPDATE_JPSTORE_GMO_EXTRA_PARAM, res);
      if (this.selectedItem.id && Object.keys(this.formData).length > 0) {
        this.$emit('submit');
      }
    }
  },
  watch: {
    'selectedItem.id'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.$store.commit(RESET_JPSTORE_CHILD_FORM);
        this.$store.commit(RESET_JPSTORE_GMO_EXTRA_PARAM);
        this.resetFormValue();
        this.$store
          .dispatch(GET_JPSTORE_CHILD_FORM, {
            fType: this.curPayType.f_pay_type,
            pay_type: this.curPayType.pay_type,
            child_id: newVal
          })
          .then(res => {
            this.canClick = true;
            this.isload = true;
          });
      }
    }
  }
};
</script>

<template>
  <div class="gmo-select-popup">
    <div class="popup-mask" @click="hidePopup"></div>
    <div class="gmo-select-popup-container">
      <div class="close-btn" @click="hidePopup">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="gmo-header">
        <div class="back-btn" @click="hidePopup">
          <span class="iconfont icon-back"></span>
        </div>
        <h1>お支払い</h1>
      </div>
      <div class="amount-display">
        <div class="amount">
          <template v-if="discountTransMount && discountTransMount !== amountDesc">
            <span class="original-price">{{amountDesc}}</span>
            <span class="number">{{discountTransMount}}</span>
            <span class="currency">円</span>
          </template>
          <template v-else>
            <span class="number">{{amountDesc}}</span>
            <span class="currency">円</span>
          </template>
        </div>
        <div class="amount-detail">{{postProductDesc}}</div>
      </div>
      <div class="gmo-select-popup-content">
        <div class="payment-section">
          <div class="payment-item" @click="toggleDropdown">
            <div class="payment-logo">
              <template v-if="selectedItem">
                <img
                  :src="`//jpabres.37games.com/h5Game/${selectedItem.id}.png`"
                  :alt="selectedItem.name"
                />
                <span>{{ selectedItem.name }}</span>
              </template>
              <template v-else>
                <span class="placeholder">支払い方法を選択してください</span>
              </template>
            </div>
            <span
              class="dropdown-icon"
              :class="{ 'is-selected': selectedItem }"
            ></span>
          </div>
        </div>
        <div class="form-box">
          <div v-for="(item, key) in jpChildForm" :key="key">
            <Input
              :defaultValue="''"
              :attr="key"
              :tips="item.tips"
              :title="item.title"
              :slot="'text'"
              :msg="item.msg"
              v-on:updateValue="updateFormValue"
            />
          </div>
        </div>
        <button 
          class="submit-button" 
          :class="{'disabled': !canClick}"
          :disabled="!canClick" 
          @click="getAllData"
        >
          お支払い
        </button>
      </div>
      <div class="payment-select-popup" v-if="showDropdown">
        <div class="popup-mask" @click="toggleDropdown"></div>
        <div class="payment-list">
          <div
            v-for="(item, index) in jpChildList"
            :key="item.id"
            class="payment-list-item"
            @click="updateChildChannel(item)"
          >
            <img
              class="payment-icon"
              :src="`//jpabres.37games.com/h5Game/${item.id}.png`"
              alt="pay-icon"
              v-if="item.id"
            />
            <span class="payment-name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gmo-select-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;

  .popup-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    // z-index: -1;
  }

  &-container {
    position: relative;
    width: 56.2vh;
    max-width: 80%;
    background: #fff;
    border-radius: 0.9vh;
    transition-duration: 0.3s;
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 2.7vh;
  }

  .close-btn {
    position: absolute;
    top: 1.5vh;
    left: 1.5vh;
    width: 3vh;
    height: 3vh;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    
    svg {
      width: 100%;
      height: 100%;
    }
    
    &:hover {
      opacity: 0.7;
    }
  }

  .gmo-header {
    display: flex;
    align-items: center;
    padding: 0 0 24px;

    .back-btn {
      padding: 8px 16px;
      cursor: pointer;
      margin-left: -16px;
    }

    h1 {
      flex: 1;
      text-align: center;
      font-size: 24px;
      margin: 0;
      font-weight: normal;
    }
  }

  .amount-display {
    padding: 32px 16px;
    text-align: center;

    .amount {
      .original-price {
        font-size: 42px;
        color: #333;
        text-decoration: line-through;
        text-decoration-color: red;
        margin-right: 10px;
      }
      .number {
        font-size: 48px;
        color: #ff69b4;
      }
      .currency {
        font-size: 32px;
        margin-left: 4px;
        color: #ff69b4;
      }
    }

    .amount-detail {
      color: #ff69b4;
      margin-top: 12px;
      font-size: 18px;
    }
  }

  &-content {
    flex: 1;
    padding: 24px 0 0;

    .payment-section {
      margin-bottom: 32px;

      .payment-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border: 1px solid #ddd;
        border-radius: 8px;
        cursor: pointer;
        height: 7.2vh;
        display: flex;
        cursor: pointer;
        border-radius: 10px;
        margin-bottom: 0.9vh;
        align-items: center;
        padding-right: 1.8vh;
        box-sizing: border-box;
        border: 1px solid #b9b7b3;
        justify-content: space-between;

        .payment-logo {
          display: flex;
          align-items: center;
          gap: 16px;

          img {
            height: 32px;
          }

          span {
            font-size: 18px;
          }

          .placeholder {
            color: #999;
            font-size: 1.6vh;
          }
        }
      }
    }

    .input-section {
      .input-group {
        margin-bottom: 24px;

        label {
          display: block;
          margin-bottom: 12px;
          color: #0099ff;
          font-weight: bold;
          font-size: 16px;
        }

        input {
          width: 100%;
          padding: 16px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 18px;

          &::placeholder {
            color: #999;
          }
        }
      }
    }

    .submit-button {
      width: 100%;
      padding: 20px;
      background: #ff69b4;
      color: white;
      border: none;
      border-radius: 999px;
      font-size: 22px;
      margin-top: 24px;
      cursor: pointer;

      &:hover {
        background: darken(#ff69b4, 5%);
      }

      &.disabled {
        background-color: #9a9a9a;
        cursor: not-allowed;
      }
    }
  }
}

.payment-select-popup {
  width: 100%;
  height: 100%;

  .payment-list {
    position: absolute;
    background-color: #fff;
    width: calc(100% - 2.7vh);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #b9b7b3;
    border-radius: 10px;
    box-sizing: border-box;

    &-item {
      border: none;
      border-bottom: 1px solid #b9b7b3;
      margin-bottom: 0;
      padding: 0;
      margin: auto 1.8vh;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      height: 7.2vh;
      display: flex;
      cursor: pointer;
      margin-bottom: 0.9vh;
      align-items: center;
      padding-right: 1.8vh;
      justify-content: space-between;

      &:last-child {
        border-bottom: none;
      }

      .payment-icon {
        flex: 0 0 9.3vh;
        width: 9.3vh;
        height: 4.2vh;
      }

      .payment-name {
        flex: 1;
        color: #000;
        font-size: 1.3vh;
        font-weight: 700;
      }

      &:active {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }
  }
}

.dropdown-icon {
  width: 1.6vh;
  height: 1.6vh;
  border-left: 2px solid #999;
  border-bottom: 2px solid #999;
  transform: rotate(-45deg);
  transition: transform 0.3s;

  &.is-selected {
    border-color: #333;
  }
}
</style>
